// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4112":"css/app.6863","7232":"css/admin-app.6863"}[chunkId] + ".css";
};